import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

export const fraudCheck = createAsyncThunk('fraud/check', async (phone) => {
  const response = await $axios.get('/fraud/check', { params: { phone } });
  return response.data;
});

export const getFraudProfile = createAsyncThunk('fraud/profile', async (phone) => {
  const response = await $axios.get('/fraud/profile', { params: { phone } });
  return response.data;
});

const fraudSlice = createSlice({
  name: 'fraud',
  initialState: {
    result: null,
    loading: false,
    error: null,
    externalError: false,
  },
  reducers: {
    clearFraudResult: (state) => {
      state.result = null;
      state.error = null;
      state.externalError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fraudCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.result = null;
      })
      .addCase(fraudCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload?.data || null;
        state.externalError = action.payload?.externalError || false;
        state.error = null;
      })
      .addCase(fraudCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Fraud check failed';
        state.result = null;
      });
  },
});

export const { clearFraudResult } = fraudSlice.actions;
export default fraudSlice.reducer;
